import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="hero-section">
          <img
            src="https://images.unsplash.com/photo-1505142468610-359e7d316be0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
            className="hero-image"
            alt="Ocean wave crashing - the endless wave"
          />
          <div className="hero-content">
            <h1 className="hero-title">theEndlessWave</h1>
            {/* <p className="hero-subtitle">
              Discover the infinite beauty of nature's rhythms
            </p> */}
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
